import { ReactElement, useEffect, useState } from 'react';
import CabinetPage from '../../components/Common/CabinetPage';
import { Box, Grid, Typography, useMediaQuery } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import InProgressWidget from './InProgressWidget';
import colors from '../../colors';
import { DateTime } from 'luxon';
import CreateMeetingButton from '../../components/Schedule/CreateMeetingButton/CreateMeetingButton';
import theme from '../../theme';
import RecentlyChangedWidget from './RecentlyChangedWidget';
import MeetingPollWidget from './MeetingPollWidget';
import { isLargeFormatDevice } from '../../utils/screenSizeUtils';
// import chroma from 'chroma-js';

export const Dashboard = (
  {meetingAuditLogsLoaded, meetingsLoaded}: {meetingAuditLogsLoaded: boolean, meetingsLoaded: boolean}
): ReactElement => {
  const user = useSelector((state: RootState) => state.auth.user);
  const now =  DateTime.local().toJSDate();
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
 
  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const allLoaded = meetingAuditLogsLoaded && meetingsLoaded;

  return (
    <CabinetPage
      pageName={'Dashboard'}
      // headerBackgroundColor={isSm ? colors.white900 : chroma(colors.lavendar950).darken(0.7).hex()}
      headerBackgroundColor={colors.systemNeutral}
      headerColor={colors.systemNeutral}
      noHeader={isMd ? false : true}
      headerContent={
        isMd && user && isLargeFormatDevice() ? 
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              justifyContent: 'flex-end'
            }}>
            <CreateMeetingButton
              buttonTitle='Create Event'
            /> 
          </Box>
          : <></>
      }
      headerMinHeight={0}
    >
      <Box
        sx={{
          height: '100%',
          overflow: {sm: 'auto', md: 'hidden'},
          backgroundColor: colors.systemNeutral
        }}>
        {!isSm ? (
          <Box
            sx={{
              flexDirection: 'column',
              width: '100%',
              height: '210px',
              display: 'flex',
              paddingTop: '30px',
            }}
          >
            <Box
              sx={{
                marginLeft: '48px',
                marginRight: '48px',
                display: 'flex',
                flexDirection: 'column',
                [theme.breakpoints.down('lg')]: {
                  marginLeft: '20px',
                  marginRight: '20px',
                },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  width: '100%',
                  justifyContent: 'space-between'
                }}>
                <Typography
                  variant='h5'
                  color={colors.ink}
                  sx={{
                    display: 'flex',
                    alignItems: 'flex-end'
                  }}>
                  {now.toLocaleString('US', { weekday: 'long', day: 'numeric', month: 'long' })}
                </Typography>
                { isLargeFormatDevice() && user && !isMd && (
                  <CreateMeetingButton
                    buttonTitle='Create Event'
                    buttonSx={{
                      backgroundColor: colors.lavendar500,
                      '&:hover': {
                        backgroundColor: colors.lavendar400,
                      },
                      color: colors.ink,
                      // '&:hover':{backgroundColor: colors.greenLight}
                    }}
                  />
                )}
              </Box>
              <Typography
                variant='h1'
                noWrap
                color={colors.ink}
                sx={{
                  lineHeight: {sm: '54px', lg:'58px'},
                  fontSize: {sm: '45px', lg: '50px'}
                }}>
                Welcome, {user?.first_name}
              </Typography>
            </Box>
          </Box>
        ) : (
          <>
          </>
        )}
        <Box
          sx={{
            height: '90%',
            marginTop: '-80px',
            marginLeft: '48px',
            marginRight: '48px',
            paddingBottom: windowHeight > 900 ? '10px' : windowHeight > 800 ?
              '40px' : windowHeight > 400 ? '60px' : '80px',
            [theme.breakpoints.down('lg')]: {
              marginLeft: '20px',
              marginRight: '20px',
            },
            [theme.breakpoints.down('sm')]: {
              marginTop: '20px',
            }
          }}
        >
          <Grid size={{ xs: 12, sm: 12 }} sx={{
            height: '100%'
          }}>
            <Grid container spacing={4} sx={{
              height: '100%'
            }}>
              <Grid
                size={{ xs: 12, sm: 12, md: 7 }}
                sx={{
                  paddingBottom: { sm: 0, md: 4 },
                  height: '100%'
                }}>
                <InProgressWidget
                  allLoaded={allLoaded}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 12, md: 5 }} container spacing={4} sx={{
                height: '100%'
              }}>
                <Grid size={12} sx={{
                  height: '50%'
                }}>
                  <MeetingPollWidget
                    allLoaded={allLoaded}
                  />
                </Grid>
                <Grid size={12} sx={{
                  height: '50%'
                }}>
                  <RecentlyChangedWidget
                    allLoaded={allLoaded}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </CabinetPage>
  );
};
  
export default Dashboard;